import styled from '@emotion/styled';

export const Loading = styled.div<{ leftAlign: boolean }>`
  align-items: ${({ leftAlign }) => (leftAlign ? 'flex-start' : 'center')};
  display: flex;
  height: 100%;
  justify-content: center;
`;
